<template>
  <div
    class="toolbox-tool"
    @click="setCanvasTool"
    draggable="false"
    :style="'background-image:url(' + imagePath(image) + ');'"
    :class="{ 'active-tool': isToolActive }"
  ></div>
</template>
<script>
export default {
  name: 'tr-toolbox-tool',
  props: {
    tool: {
      type: null,
      default: function () {
        return {};
      },
    },
    image: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    isToolActive() {
      return this.$store.getters.tool === this.tool ? true : false;
    },
    prevTool() {
      return this.$store.getters.tool;
    },
  },
  methods: {
    imagePath(iconId) {
      let images = require.context('../../../../../assets/icons/book/toolbox/', false, /\.png$/);
      return images('./' + iconId + '.png');
    },
    setCanvasTool() {
      if (this.tool === 'textMarker') {
        this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', true);
      } else if (this.prevTool === 'textMarker') {
        this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
      }
      this.$store.commit('CHANGE_CANVAS_TOOLL', this.tool);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
$actualDimension: $toolboxBigIcon * 80/100;
.toolbox-tool {
  width: $actualDimension;
  height: $actualDimension;
  background-size: $actualDimension $actualDimension;
  background-repeat: no-repeat;
  cursor: pointer;
  margin-left: 8px;
  &:hover {
    box-shadow: inset 0 0 12px 3px $canvasActive;
  }
}
.toolbox-tool.active-tool {
  box-shadow: inset 0 0 12px 3px $canvasActive;
}
</style>
